export type CreditGaugeCardProps = {
  className?: string;
};

export type CreditRow = {
  label: string;
  value: string;
  success?: boolean;
};

export const CREDIT_ROWS: CreditRow[] = [
  { label: 'Payment behaviour', value: '12 days beyond terms' },
  { label: 'Court judgments', value: '1 · satisfied 2023' },
  { label: 'Insolvency events', value: 'None on record', success: true },
];

export const CREDIT_SCORE = 72;
export const CREDIT_LIMIT = 250000;
